import { StyleSheet } from 'aphrodite';
import { BrowserMediaQueries } from '../../styles/styles';

const searchSectionHeight = 60;

export const styleSheet = StyleSheet.create({
	buttonContainer: {
		display: 'flex',
		gap: '8px',
		alignItems: 'center',
	},
	newCampaignButton: {
		flexGrow: 1,
		marginLeft: 12,
		maxHeight: searchSectionHeight,
		maxWidth: 350,
		[BrowserMediaQueries.IE11]: {
			flexGrow: 0,
		},
	},
	buttonWrapper: {
		display: 'flex',
	},
	fullWidthButton: {
		width: '100%',
		marginLeft: 'auto',
	},
});
